import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { currentTab, socialAuths, loading, createTabs, createCurrentTabComponent } from './state'
import { changeTab } from './methods/change-tab'
import { checkAuth } from './methods/check-auth'
import { checkPendingIntegration } from './methods/check-pending-integration'
import { updateCurrentTab } from './methods/update-current-tab'

/**
 * Social media tabs management composable
 * @param {Object} options - Configuration options
 * @param {string} options.defaultTab - Default tab to display
 * @param {Array} options.components - Available component mappings
 * @returns {Object} Tabs state and methods
 */
export function useSocialMediaTabs(options = {}) {
  const { defaultTab = 'posts', components = {} } = options

  const route = useRoute()
  const router = useRouter()
  const { t } = useI18n()

  // Initialize currentTab from route or defaultTab
  currentTab.value = route.query.tab || defaultTab

  // Create computed tabs with proper t function
  const tabs = createTabs(components, t)
  const currentTabComponent = createCurrentTabComponent(tabs)

  // Watch for route changes
  watch(() => route.query.tab, (newTab) => {
    currentTab.value = newTab || defaultTab
  })

  return {
    // State
    currentTab,
    socialAuths,
    loading,
    tabs,
    currentTabComponent,

    // Methods
    changeTab: (tabName) => changeTab(tabName, route, router),
    checkAuth,
    checkPendingIntegration: () => checkPendingIntegration(route),
    updateCurrentTab: () => updateCurrentTab(route, defaultTab),
  }
}
